module.exports = __webpack_public_path__ + "static/img/logo.c8fbd94f.png";